<template>
  <v-autocomplete
    v-model="input"
    :items="items"
    :dense="dense"
    item-value="value"
    item-text="name"
    @blur="$emit('blur')"
    @click="$emit('click')"
    append-icon="mdi-chevron-down"
    outlined
    @input="$emit('input', input)"
    v-bind="$attrs"
    :rules="getRules"
  >
    <template v-slot:selection="{ item, index }" v-if="isTemplate">
      <template v-if="isObject(item)">
        <span v-if="index === 0">{{ item.name }}</span>
        <span
          v-if="index === 1"
          class="grey--text caption autocomplete-selection"
        >
          (+{{ value.length - 1 }} others)
        </span>
      </template>
      <template v-else>
        <span v-if="index === 0">{{ item }}</span>
        <span
          v-if="index === 1"
          class="grey--text caption autocomplete-selection"
        >
          (+{{ value.length - 1 }} others)
        </span>
      </template>
    </template>
  </v-autocomplete>
</template>

<script>
import { getRules } from "../../../assets/js/common";
export default {
  inheritAttrs: false,
  props: {
    value: {},
    isTemplate: {
      type: Boolean,
      default: true,
    },
    items: {
      type: Array,
      default: () => [],
    },
    dense: {
      type: Boolean,
      default: true,
    },
    outlined: {
      type: Boolean,
      default: true,
    },
    rules: {
      type: String,
      default: "",
    },
    customRules: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      input: "",
    };
  },
  computed: {
    getRules() {
      let { customRules, rules } = this;
      if (customRules.length > 0) return customRules;
      return getRules(rules);
    },
  },
  watch: {
    value(val) {
      this.input = val;
    },
  },
  methods: {
    isObject(item) {
      return item instanceof Object;
    },
  },
  mounted() {
    this.input = this.value;
  },
};
</script>

<style>
.autocomplete-selection {
  white-space: nowrap;
  overflow: hidden;
}
</style>
